import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AdobelaunchService } from '../_services/adobelaunch.service';

@Component({
    selector: 'app-apifailuremessage',
    templateUrl: './apifailuremessage.component.html',
    styleUrls: ['./apifailuremessage.component.scss'],
    standalone: false
})
export class ApifailuremessageComponent implements OnInit,AfterViewInit {
  
  errorMessage: string = "We're sorry, an error has occurred while processing your request. Please try again later.";

  constructor(
    private readonly AdobelaunchService: AdobelaunchService,
    private readonly route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['rf'] === 'notfound') {
        this.errorMessage = "Failed to retrieve company information.";
      }
    });
  }

  ngAfterViewInit() {     
    this.AdobelaunchService.EventEndDispatch();
    setTimeout(() => {
      window.location.href = '/';
    }, 5000);
  }
}
